import React from 'react'

import classnames from 'classnames'

import { Tag } from '../../../../Tag'
import styles from './ProductCardTags.module.scss'

export const ProductCardTags = ({ className, tags }: Props) => {
  if (!tags) {
    return null
  }

  return (
    <ul
      className={classnames(styles.list, className)}
      data-testid="product-tags"
    >
      {tags.map((tag) => (
        <li key={tag} data-testid="product-tag">
          <Tag text={tag} />
        </li>
      ))}
    </ul>
  )
}

type Props = {
  className?: string
  tags?: Array<string> | null
}
